export const AUTH0_METADATA_NAMESPACE = 'https://marinedatacloud.com/account/user_metadata';
export const SCROLL_CONTAINER_ID = 'scroll__container';
